import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(() => ({
  textDecoration: 'none'
}));

// Use $align instead of align
export const ActionsContent = styled('div')(({ theme, $align }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: $align === 'right' ? 'flex-end' : 'flex-start',
  margin: theme.spacing(-1),
  [`& ${Button}`]: {
    margin: theme.spacing(1)
  }
}));

// Use $image instead of image
export const Container = styled('div')(({ theme, $image }) => ({
  alignContent: 'flex-start',
  background: `top right / cover url(${$image}) no-repeat`,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  minHeight: '250px',
  padding: theme.spacing(3)
}));

export const Subject = styled('h2')(({ theme }) => ({
  color: theme.color.primary.contrast,
  fontWeight: theme.fontWeight.bold,
  margin: '0px',
  textTransform: 'uppercase'
}));

export const Text = styled('p')(({ theme }) => ({
  color: theme.color.primary.contrast
}));
